import { render, staticRenderFns } from "./no-direccion.vue?vue&type=template&id=22554e2c&"
import script from "./no-direccion.vue?vue&type=script&lang=js&"
export * from "./no-direccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports